import http from "../api/apiClient";

const normalizeParents = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.content)) return data.content;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const fetchNewsletterCounts = async () => {
  try {
    const { data } = await http.get("/parents");
    const parents = normalizeParents(data);

    let subscribed = 0;
    let optedOut = 0;

    parents.forEach((parent) => {
      const hasOptedOut = !!parent?.newsletterOptOut;
      if (hasOptedOut) {
        optedOut += 1;
      } else if (parent?.newsletterStatus === "SUBSCRIBED") {
        subscribed += 1;
      }
    });

    return { subscribed, optedOut };
  } catch (error) {
    if (error?.response?.status === 403) {
      return { subscribed: 0, optedOut: 0 };
    }
    throw error;
  }
};
